//export const BASE_URL = "https://www.horst-it.de/messdaten/api";
export const BASE_URL = "https://www.sencono.de/messdaten/api";

export const developParams = false; // "?customerrequest=true";
//export const developParams = "?customerrequest=true";

export const showProtokoll = false;
export const showRequest = false;

export const Events = {
  BRANCH_CHANGE: "BRANCH_CHANGE",
  SENSOR_ACTIVATE: "SENSOR_ACTIVATE",
  SENSOR_CHANGE: "SENSOR_CHANGE",
  BOARD_CHANGE: "BOARD_CHANGE",
  FIRM_SELECT: "FIRM_SELECT",
};

export const lightColorDefs = {
  Background: {
    backgroundColor: "#fff",
  },
  Border: {
    borderColor: "#eee",
    borderBottomColor: "#eee",
    borderTopColor: "#eee",
  },
  BorderC: {
    borderColor: "#cccccc",
  },
  diagramBorder: {
    borderColor: "#000000",
  },
  welcomeText: {
    color: "#20315f",
  },
  defaultText: {
    color: "#000000",
  },
  grayText: {
    color: "#333333",
  },
  lightGrayText: {
    color: "#666666",
  },
  silverText: {
    color: "#888888",
  },
  errorText: {
    color: "#ff0000",
  },
  adminInfoText: {
    color: "#800000",
  },
  resultText: {
    color: "#d80000",
  },
  idText: {
    activeColor: "green",
    inactiveColor: "gray",
  },
  placeholderText: {
    placeholderColor: "#888",
    placeholderDisabledColor: "#aaa",
  },
  buttonText: {
    color: "#fff",
  },
  linkText: {
    color: "#00f",
  },
  grayIcon: {
    color: "#666666",
  },
  disabledIcon: {
    color: "#aaaaaa",
  },
  lightGrayIcon: {
    color: "#cccccc",
  },
  Drawer: {
    activeBackgroundColor: "#407daf",
    activeTintColor: "#ffffff",
    inactiveTintColor: "#333333",
  },
  drawerCustomText: {
    color: "#333333",
  },
  pickerStyle: {
    doinvert: false,
  },
  passwordStrength: {
    passwordStrengthColors: {
      strongColor: "#00b400",
      mediumColor: "#b4b400",
      weakColor: "#b40000",
      defaultColor: "#808080",
    },
  },
  switchColors: {
    blueOnColor: "#4785b8",
    greenOnColor: "green",
    offColor: "gray",
    disabledColor: "lightgray",
    circleActiveColor: "#eeeeee",
    circleInActiveColor: "#eeeeee",
    blueTextColor: "#4785b8",
    greenTextColor: "green",
    offTextColor: "lightgray",
  },
  checkColors: {
    backgroundColor: "#aeffae",
    foregroundColor: "#000",
    assignColor: "#800000",
  },
  rssiImage: {
    goodColor: "#000000",
    badColor: "#660000",
    weakColor: "#666600",
    doincrease: true,
  },
  modalBackground: {
    backgroundColor: "#24242799"
  },
};
export const darkColorDefs = {
  Background: {
    backgroundColor: "#242729",
    //backgroundColor: "#151718",
  },
  Border: {
    borderColor: "#333",
    borderBottomColor: "#333",
    borderTopColor: "#333",
  },
  BorderC: {
    borderColor: "#666",
  },
  diagramBorder: {
    borderColor: "#888888",
  },
  welcomeText: {
    color: "#4b6fd3",
  },
  defaultText: {
    color: "#e0e0e0",
  },
  grayText: {
    color: "#888888",
  },
  lightGrayText: {
    color: "#666666",
  },
  silverText: {
    color: "#666666",
  },
  errorText: {
    color: "#ff8686",
  },
  adminInfoText: {
    color: "#800000",
  },
  resultText: {
    color: "#d80000",
  },
  idText: {
    activeColor: "#006100",
    inactiveColor: "#666",
  },
  placeholderText: {
    placeholderColor: "#444",
    placeholderDisabledColor: "#222",
  },
  buttonText: {
    color: "#000",
  },
  linkText: {
    color: "#3775fa",
  },
  grayIcon: {
    color: "#aaaaaa",
  },
  disabledIcon: {
    color: "#888888",
  },
  lightGrayIcon: {
    color: "#666666",
  },
  Drawer: {
    activeBackgroundColor: "#407daf",
    activeTintColor: "#000000",
    inactiveTintColor: "#cccccc",
  },
  drawerCustomText: {
    color: "#cccccc",
  },
  pickerStyle: {
    doinvert: true,
  },
  passwordStrength: {
    passwordStrengthColors: {
      strongColor: "#00b400",
      mediumColor: "#b4b400",
      weakColor: "#b40000",
      defaultColor: "#808080",
    },
  },
  switchColors: {
    blueOnColor: "#4785b8",
    greenOnColor: "#5ebb5e",
    offColor: "#666666",
    disabledColor: "lightgray",
    circleActiveColor: "#333333",
    circleInActiveColor: "#333333",
    blueTextColor: "#4785b8",
    greenTextColor: "#5ebb5e",
    offTextColor: "#555555",
  },
  checkColors: {
    backgroundColor: "#466946",
    foregroundColor: "#e0e0e0",
    assignColor: "#c90000",
  },
  rssiImage: {
    goodColor: "#ebebeb",
    badColor: "#bb0000",
    weakColor: "#bbbb00",
    doincrease: false,
  },
  modalBackground: {
    backgroundColor: "#77777799"
  },
};
